(function () {
  // Match vendor layout utilities (medium-up = min-width 769px). At 769 the drawer
  // trigger is medium-up--hide'd, so BOA must treat 769 as desktop — not config's 769 small.
  const MOBILE_MQ = '(max-width: 768px)';
  const DRAWER_CLASS = 'boa-filter-drawer-open';
  const DESKTOP_OPEN_CLASS = 'boa-desktop-filters-open';
  const DESKTOP_OPEN_KEY = 'boa-desktop-filters-open';
  const nativeScrollTo = window.scrollTo.bind(window);

  let keepOpen = false;
  let savedScrollY = 0;
  let scrollGuardDepth = 0;

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function triggerBtn() {
    return document.querySelector('.collection-filter__btn');
  }

  function mobileWrap() {
    return document.querySelector('.collection-mobile-filters .filter-wrapper');
  }

  function isDrawerOpen() {
    return Boolean(triggerBtn()?.classList.contains('is-active') || mobileWrap()?.classList.contains('is-active'));
  }

  function setOpenClass(open) {
    document.documentElement.classList.toggle(DRAWER_CLASS, Boolean(open && isMobile()));
  }

  function setDrawerInert(wrap, open) {
    if (!wrap) {
      return;
    }
    wrap.toggleAttribute('inert', !open);
    if (open) {
      wrap.setAttribute('aria-modal', 'true');
      wrap.setAttribute('role', 'dialog');
    } else {
      wrap.removeAttribute('aria-modal');
      wrap.removeAttribute('role');
    }
  }

  function syncSidebarOpen(open) {
    const grid = document.querySelector('.item-grid');
    const sidebar = grid?.sidebar;
    if (typeof sidebar?.syncOpen === 'function') {
      sidebar.syncOpen(open);
      return;
    }
    // Components update without syncOpen: still clear/set classes so B1 cannot return silently.
  }

  function forceClosedClasses() {
    const btn = triggerBtn();
    const wrap = mobileWrap();
    wrap?.classList.remove('is-active', 'is-transitioning');
    btn?.classList.remove('is-active');
    setDrawerInert(wrap, false);
    setOpenClass(false);
    syncSidebarOpen(false);
  }

  function desktopGrid() {
    // Prefer a real <item-grid>; is-land may briefly swap in a placeholder twin.
    return document.querySelector('item-grid.item-grid') || document.querySelector('.item-grid');
  }

  function isDesktopOpen() {
    return Boolean(desktopGrid()?.classList.contains(DESKTOP_OPEN_CLASS));
  }

  function readDesktopOpen() {
    try {
      return sessionStorage.getItem(DESKTOP_OPEN_KEY) === '1';
    } catch (err) {
      return false;
    }
  }

  function setDesktopOpen(open, { focusTitle } = {}) {
    const grid = desktopGrid();
    if (!grid) {
      return;
    }
    const next = Boolean(open);
    grid.classList.toggle(DESKTOP_OPEN_CLASS, next);
    grid.querySelectorAll('[data-boa-desktop-filter-open]').forEach((btn) => {
      btn.setAttribute('aria-expanded', next ? 'true' : 'false');
    });
    try {
      if (next) {
        sessionStorage.setItem(DESKTOP_OPEN_KEY, '1');
      } else {
        sessionStorage.removeItem(DESKTOP_OPEN_KEY);
      }
    } catch (err) {
      // sessionStorage can be blocked; class on the grid is enough for this page.
    }
    if (focusTitle && !next) {
      grid.querySelector('[data-boa-desktop-filter-open]')?.focus();
    }
  }

  function syncDesktopOpenFromStorage() {
    if (isMobile()) {
      return;
    }
    setDesktopOpen(readDesktopOpen());
  }

  // is-land swaps a placeholder then restores the original — re-apply after ready.
  function bindDesktopOpenAfterIsland() {
    document.querySelectorAll('is-land').forEach((island) => {
      if (island.ready && typeof island.ready.then === 'function') {
        island.ready.then(syncDesktopOpenFromStorage);
      }
    });
  }

  // Mobile sort is a floating panel — close without requiring a second trigger tap (NB-6).
  function closeOpenSortPanel(root) {
    const scope = root || mobileWrap();
    if (!scope) {
      return false;
    }
    const sortGroup = scope.querySelector('.boa-filter-group--sort');
    if (!sortGroup) {
      return false;
    }
    const trigger = sortGroup.querySelector('.collapsible-trigger.is-open');
    const content = sortGroup.querySelector('.collapsible-content.is-open');
    if (!trigger && !content) {
      return false;
    }
    if (trigger) {
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    if (content) {
      content.classList.remove('is-open');
      content.style.height = '0px';
    }
    return true;
  }

  function closeDrawer() {
    keepOpen = false;
    closeOpenSortPanel();
    if (!isMobile()) {
      // Resize left mobile-open classes behind — clear them fully.
      forceClosedClasses();
      return;
    }
    setOpenClass(false);
    const btn = triggerBtn();
    const wrap = mobileWrap();
    syncSidebarOpen(true);
    if (btn?.classList.contains('is-active')) {
      btn.click();
    } else {
      wrap?.classList.remove('is-active');
      btn?.classList.remove('is-active');
    }
    syncSidebarOpen(false);
    setDrawerInert(mobileWrap(), false);
  }

  const EXPANDED_KEY = 'boa-filter-expanded';

  function getExpandedKeys() {
    try {
      return JSON.parse(sessionStorage.getItem(EXPANDED_KEY) || '[]');
    } catch {
      return [];
    }
  }

  function saveExpandedKey(key) {
    if (!key) {
      return;
    }
    try {
      const keys = getExpandedKeys();
      if (!keys.includes(key)) {
        keys.push(key);
        sessionStorage.setItem(EXPANDED_KEY, JSON.stringify(keys));
      }
    } catch {
      // private mode / quota — show-more just won't persist
    }
  }

  function removeExpandedKey(key) {
    if (!key) {
      return;
    }
    try {
      const keys = getExpandedKeys().filter((item) => item !== key);
      sessionStorage.setItem(EXPANDED_KEY, JSON.stringify(keys));
    } catch {
      // private mode / quota — show-more just won't persist
    }
  }

  function syncShowMoreLabel(group, expanded) {
    const btn = group?.querySelector('[data-boa-show-more]');
    if (!btn) {
      return;
    }
    const label = expanded ? btn.dataset.lessText : btn.dataset.moreText;
    if (label) {
      btn.textContent = label;
    }
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function applyExpandedState(root) {
    if (!root) {
      return;
    }
    const keys = getExpandedKeys();
    root.querySelectorAll('.boa-filter-group').forEach((group) => {
      const id = group.querySelector('[data-collapsible-id]')?.dataset.collapsibleId;
      const expanded = Boolean(id && keys.includes(id));
      group.classList.toggle('is-expanded', expanded);
      syncShowMoreLabel(group, expanded);
    });
  }

  function prefixCloneIds(root) {
    if (!root || root.dataset.boaIdsPrefixed === '1') {
      return;
    }
    root.querySelectorAll('[id]').forEach((el) => {
      if (!el.id.startsWith('mobile-')) {
        el.id = `mobile-${el.id}`;
      }
    });
    root.querySelectorAll('[for]').forEach((el) => {
      const value = el.getAttribute('for');
      if (value && !value.startsWith('mobile-')) {
        el.setAttribute('for', `mobile-${value}`);
      }
    });
    root.dataset.boaIdsPrefixed = '1';
  }

  function revivePriceRanges(root) {
    if (!root) {
      return;
    }
    const start = () => {
      root.querySelectorAll('price-range').forEach((el) => {
        if (typeof el.init === 'function') {
          el.init();
        }
      });
    };
    if (customElements.get('price-range')) {
      start();
      return;
    }
    customElements.whenDefined('price-range').then(start);
    // Cloned filter DOM includes <price-range>; inject the module if the page skipped it.
    if (!document.querySelector('script[data-boa-price-range]')) {
      const script = document.createElement('script');
      script.type = 'module';
      script.dataset.boaPriceRange = '';
      script.textContent = "import 'components/price-range'";
      document.head.append(script);
    }
  }

  function bindMobileClone(wrap, grid) {
    if (!wrap || !grid) {
      return;
    }
    wrap.querySelectorAll('.filter-form').forEach((form) => {
      form.addEventListener('input', grid.onFormSubmit.bind(grid), { signal: grid.abortController.signal });
    });
    wrap.querySelectorAll('.filter-sort').forEach((btn) => {
      btn.addEventListener(
        'click',
        () => {
          closeOpenSortPanel(wrap);
          document.dispatchEvent(new Event('filter:selected'));
          grid.onSortChange(btn.dataset.value);
        },
        { signal: grid.abortController.signal }
      );
    });
    wrap.querySelectorAll('.tag-list a').forEach((tag) => {
      tag.addEventListener('click', grid.onTagClick.bind(grid), { signal: grid.abortController.signal });
    });
  }

  function syncMobileFromDesktop({ forceOpen } = {}) {
    const sidebarWrap = document.querySelector('#CollectionSidebarFilterWrap .filter-wrapper');
    const holder = document.querySelector('#CollectionInlineFilterWrap');
    const grid = document.querySelector('.item-grid');
    if (!sidebarWrap || !holder) {
      return null;
    }
    const clone = sidebarWrap.cloneNode(true);
    prefixCloneIds(clone);
    if (forceOpen) {
      clone.classList.add('is-active');
    }
    setDrawerInert(clone, Boolean(forceOpen));
    holder.replaceChildren(clone);
    revivePriceRanges(clone);
    bindMobileClone(clone, grid);
    // CollectionSidebar keeps pointing at #CollectionInlineFilterWrap after clone swap.
    if (grid?.sidebar) {
      grid.sidebar.wrapper = holder;
      grid.sidebar.filters = clone;
    }
    applyExpandedState(sidebarWrap);
    applyExpandedState(clone);
    return clone;
  }

  // Always refresh the mobile mirror after AJAX so a closed drawer isn't one render behind (clear-all).
  function restoreDrawer() {
    if (!isMobile()) {
      forceClosedClasses();
      return;
    }
    if (!keepOpen) {
      syncMobileFromDesktop();
      setOpenClass(false);
      syncSidebarOpen(false);
      return;
    }
    syncMobileFromDesktop({ forceOpen: true });
    const wrap = mobileWrap();
    const btn = triggerBtn();
    if (!wrap || !btn) {
      return;
    }
    wrap.classList.add('is-active');
    wrap.classList.remove('is-transitioning');
    btn.classList.add('is-active');
    setDrawerInert(wrap, true);
    setOpenClass(true);
    // Sync vendor flag without btn.click() (avoids keyup leaks + toggle race after init()).
    syncSidebarOpen(true);
    nativeScrollTo(0, savedScrollY);
  }

  function pickSearchEmptyState() {
    const plain = document.querySelector('[data-boa-search-empty-plain]');
    const grid = document.querySelector('[data-boa-search-empty-filtered]');
    if (!plain && !grid) {
      return;
    }
    const filtered = /(?:^|[?&])filter\./.test(window.location.search);
    if (filtered) {
      plain?.classList.add('hide');
      if (grid) {
        grid.classList.remove('hide');
        grid.querySelectorAll('[data-boa-search-clear-wrap]').forEach((el) => {
          el.classList.remove('hide');
        });
      }
    } else {
      plain?.classList.remove('hide');
      grid?.classList.add('hide');
    }
  }

  document.addEventListener(
    'filter:selected',
    (event) => {
      const open = isMobile() && isDrawerOpen();
      keepOpen = open;
      savedScrollY = window.scrollY;
      // Only veto CollectionSidebar.close while the mobile drawer must stay open.
      if (open) {
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest('.collection-filter__btn')) {
        return;
      }
      const y = window.scrollY;
      // CollectionSidebar.open() scrolls to top; block until rAF restores position.
      scrollGuardDepth += 1;
      window.scrollTo = function () {};
      setTimeout(() => {
        scrollGuardDepth -= 1;
        if (scrollGuardDepth <= 0) {
          scrollGuardDepth = 0;
          window.scrollTo = nativeScrollTo;
        }
        nativeScrollTo(0, y);
      }, 0);
      requestAnimationFrame(() => {
        const wrap = mobileWrap();
        prefixCloneIds(wrap);
        const open = isDrawerOpen();
        wrap?.classList.toggle('is-active', open);
        wrap?.classList.remove('is-transitioning');
        setDrawerInert(wrap, open);
        setOpenClass(open);
        if (open) {
          revivePriceRanges(wrap);
        }
        if (!open) {
          keepOpen = false;
        }
      });
    },
    true
  );

  document.addEventListener(
    'price-range:change',
    () => {
      keepOpen = isMobile() && isDrawerOpen();
      savedScrollY = window.scrollY;
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-boa-filter-close]')) {
      event.preventDefault();
      if (isMobile()) {
        closeDrawer();
      } else {
        setDesktopOpen(false, { focusTitle: true });
      }
      return;
    }

    const desktopOpen = event.target.closest('[data-boa-desktop-filter-open]');
    if (desktopOpen && !isMobile() && !isDesktopOpen()) {
      event.preventDefault();
      setDesktopOpen(true);
      return;
    }

    const showMore = event.target.closest('[data-boa-show-more]');
    if (showMore) {
      event.preventDefault();
      const group = showMore.closest('.boa-filter-group');
      if (!group) {
        return;
      }
      const expanded = !group.classList.contains('is-expanded');
      group.classList.toggle('is-expanded', expanded);
      const key = group.querySelector('[data-collapsible-id]')?.dataset.collapsibleId;
      if (expanded) {
        saveExpandedKey(key);
      } else {
        removeExpandedKey(key);
      }
      syncShowMoreLabel(group, expanded);
      // Vendor fixed inline height — clear so show-more growth is visible (B2).
      const content = group.querySelector('.collapsible-content.is-open');
      if (content) {
        content.style.height = 'auto';
      }
      return;
    }

    const clear = event.target.closest('[data-boa-clear-filters]');
    if (!clear) {
      return;
    }
    event.preventDefault();
    keepOpen = isMobile() && isDrawerOpen();
    savedScrollY = window.scrollY;
    const grid = document.querySelector('.item-grid');
    if (!grid || typeof grid.renderCollectionPage !== 'function') {
      window.location.href = clear.href;
      return;
    }
    if (grid.isAnimating) {
      return;
    }
    const url = new URL(clear.href, window.location.origin);
    grid.isAnimating = true;
    grid.startLoading();
    grid.renderCollectionPage(url.searchParams);
  });

  document.addEventListener('collection:reloaded', () => {
    restoreDrawer();
    applyExpandedState(document.querySelector('#CollectionSidebarFilterWrap .filter-wrapper'));
    pickSearchEmptyState();
    syncDesktopOpenFromStorage();
  });

  // Closed drawer must stay inert + id-prefixed even if the vendor clone wins a race.
  function sealClosedDrawer() {
    const wrap = mobileWrap();
    if (!wrap) {
      return;
    }
    prefixCloneIds(wrap);
    if (!isDrawerOpen()) {
      setDrawerInert(wrap, false);
    }
  }

  function takeOverClone() {
    const C = customElements.get('item-grid');
    if (!C || C.prototype.cloneFiltersOnMobile?.__boa) {
      return;
    }
    function cloneFiltersOnMobile() {
      if (this.config.mobileFiltersInPlace) {
        return;
      }
      syncMobileFromDesktop({ forceOpen: false });
      this.config.mobileFiltersInPlace = true;
    }
    cloneFiltersOnMobile.__boa = true;
    C.prototype.cloneFiltersOnMobile = cloneFiltersOnMobile;
    // connectedCallback may already have used the vendor clone — rebuild once.
    document.querySelectorAll('item-grid').forEach((grid) => {
      grid.config.mobileFiltersInPlace = false;
      grid.cloneFiltersOnMobile();
    });
  }

  if (customElements.get('item-grid')) {
    takeOverClone();
  } else {
    customElements.whenDefined('item-grid').then(takeOverClone);
  }

  // Bound vendor matchSmall handlers still clone without our seal — fix after they run.
  document.addEventListener('matchSmall', () => {
    requestAnimationFrame(sealClosedDrawer);
  });

  // Tap outside the floating sort panel (brand / price / etc.) dismisses it.
  document.addEventListener(
    'click',
    (event) => {
      if (!isMobile() || !isDrawerOpen()) {
        return;
      }
      const wrap = mobileWrap();
      if (!wrap || !wrap.contains(event.target)) {
        return;
      }
      if (!wrap.querySelector('.boa-filter-group--sort .collapsible-content.is-open')) {
        return;
      }
      if (event.target.closest('.boa-filter-group--sort')) {
        return;
      }
      closeOpenSortPanel(wrap);
    },
    true
  );

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape' || !document.documentElement.classList.contains(DRAWER_CLASS)) {
      return;
    }
    if (closeOpenSortPanel()) {
      return;
    }
    closeDrawer();
  });

  // Desktop↔mobile resize: rebuild the mobile mirror after desktop AJAX wiped it (B1),
  // and clear sticky open chrome when leaving mobile.
  window.matchMedia(MOBILE_MQ).addEventListener('change', (event) => {
    if (event.matches) {
      const grid = document.querySelector('item-grid');
      if (grid) {
        grid.config.mobileFiltersInPlace = false;
        grid.cloneFiltersOnMobile();
        grid.sidebar?.init();
      }
      sealClosedDrawer();
      return;
    }
    forceClosedClasses();
    keepOpen = false;
  });

  sealClosedDrawer();
  requestAnimationFrame(sealClosedDrawer);
  pickSearchEmptyState();
  syncDesktopOpenFromStorage();
  requestAnimationFrame(syncDesktopOpenFromStorage);
  bindDesktopOpenAfterIsland();
})();
